module.exports = __webpack_public_path__ + "img/delete.de1acbe6.svg";